module.exports = __webpack_public_path__ + "static/media/60Hou.d7d3a72f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/60Hou.png
// module id = 1679
// module chunks = 0 1